import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import Spacer from '../../../components/presentational/Spacer';
import Typography from '../../../components/presentational/Typography';
import articleSharingStyles from './ArticleSharing_styles';
import { withQuery } from '../../../lib/stringUtils';
import { Brand } from '../../../lib/theme';

type ArticleSharingNetwork = 'email' | 'facebook' | 'twitter' | 'pinterest';

export interface ArticleSharingProps {
  link: string;
  onShare?: (network: ArticleSharingNetwork) => any;
  brand?: Brand
}

const utmCode = (brand) => {
  return (brand.toLowerCase() == 'tas' ? 
    `utm_source=dir&utm_medium=dis&utm_campaign=TAS-Share&utm_id=tra:oth:oth:mp::` : 
    `utm_source=dir&utm_medium=dis&utm_campaign=SAS-Share&utm_id=med:oth:oth:mp::`)
}

const ArticleSharing = ({
  link,
  onShare,
  brand = 'sas',
  styles,
}: ArticleSharingProps & StylesProps<typeof articleSharingStyles>) => (
  <Spacer row className={styles.shares} width={'auto!important'}>
    <Typography>
      <small>Share:</small>
    </Typography>

    <Spacer row width={'auto!important'}>
      {(link ?
      <a
        className={styles.shareLink}
        href={withQuery(`mailto://`, {
          subject: `Check out this page that I found - ${link}?source=website&${utmCode(brand)}`,
        })}
        title={'Share via email'}
        target={'_blank'}
        onClick={() => onShare && onShare('email')}
        rel={'noreferrer noopener'}
      >
        <img
          className={styles.shareLinkImage}
          src={'//images.startsat60.com/frontend/social/email.png'}
          width={24}
          alt={'Share via email'}
        />
      </a>
      : '')}
      <a
        className={styles.shareLink}
        href={withQuery('//www.facebook.com/sharer/sharer.php', {
          u: `${link}?source=facebook&${utmCode(brand)}`,
        })}
        title={'Share on Facebook'}
        target={'_blank'}
        onClick={() => onShare && onShare('facebook')}
        rel={'noreferrer noopener'}
      >
        <img
          className={styles.shareLinkImage}
          src={'//images.startsat60.com/frontend/social/facebook.png'}
          width={24}
          alt={'Share on Facebook'}
        />
      </a>

      {/* <a
        className={styles.shareLink}
        href={withQuery('//twitter.com/share', {
          url: `${link}?source=twitter&${utmCode(brand)}`,
        })}
        title={'Share on Twitter'}
        target={'_blank'}
        onClick={() => onShare && onShare('twitter')}
        rel={'noreferrer noopener'}
      >
        <img
          className={styles.shareLinkImage}
          src={'//images.startsat60.com/frontend/social/twitter.png'}
          width={24}
          alt={'Share on Twitter'}
        />
      </a>

      <a
        className={styles.shareLink}
        href={withQuery('//pinterest.com/pin/create/link', {
          url: `${link}?source=pinterest&${utmCode(brand)}`,
        })}
        title={'Share on Pinterest'}
        target={'_blank'}
        onClick={() => onShare && onShare('pinterest')}
        rel={'noreferrer noopener'}
      >
        <img
          className={styles.shareLinkImage}
          src={'//images.startsat60.com/frontend/social/pinterest.png'}
          width={24}
          alt={'Share on Pinterest'}
        />
      </a> */}
    </Spacer>
  </Spacer>
);

export default styled(articleSharingStyles)(ArticleSharing);
